import { render } from "./unAuthorized.vue?vue&type=template&id=f8a70a68"
import script from "./unAuthorized.vue?vue&type=script&lang=js"
export * from "./unAuthorized.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__